// ./resources/app.jsx
import React, { Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Provider, useDispatch } from 'react-redux';
import store from '@/store';
import { setCaptchaVerified } from '@/store/runtimeSlice';

// import Guides from "@/Pages/Guide"

// AXIOS SETUP
import axios from 'axios';
window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// CSS (adjust as needed)
import '@/css/app.css';

// KEYCLOAK & CAPTCHA
import ReCAPTCHA from 'react-google-recaptcha';

// Lazy-loaded pages
const Home = lazy(() => import('@/Pages/Home'));
const SearchPage = lazy(() => import('@/Pages/Search'));
const Favourites = lazy(() => import('@/Pages/Favourites'));
const Guides = lazy(() => import('@/Pages/Guide'));
const About = lazy(() => import('@/Pages/AboutUs'));
const FAQ = lazy(() => import('@/Pages/Faq'));
const TermsAndConditions = lazy(() => import('@/Pages/TermsAndConditions'));
const PrivacyPolicy = lazy(() => import('@/Pages/PrivacyPolicy'));
const Disclaimer = lazy(() => import('@/Pages/Disclaimer'));

// Optional: Create a fallback component for loading state
const Loading = () => <div>Loading...</div>;

function AppRoutes() {
  const dispatch = useDispatch();

  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/favourites" element={<Favourites />} />
        <Route path="/guides" element={<Guides />} />
        <Route path="/about" element={<About />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
      </Routes>
    </Suspense>
  );
}

// Finally, mount the root
const container = document.getElementById('root');
createRoot(container).render(
  <Provider store={store}>
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  </Provider>
);

<a
href="/disclaimer"
className="hover:text-neutral-600 hover:underline"
>
Disclaimer
</a>